import * as UsersActions from '../actions/users.actions';

const INITIAL_STATE = {
  entities: {},
  ids: [],
  isLoading: false,
  loadingById: {},
  roles: [],
  msg: null,
  path: null,
  nav: false,
};

export default function users(state = INITIAL_STATE, action = '') {
  switch (action.type) {
    case UsersActions.LOAD_USERS:
    case UsersActions.LOAD_USERS_FAILED:
    case UsersActions.LOAD_CURRENT_USER:
    case UsersActions.LOAD_CURRENT_USER_FAILED:
    case UsersActions.CREATE:
      return {
        ...state,
        isLoading: true,
        msg: null,
        path: null,
        nav: false,
      };

    case UsersActions.LOAD_USERS_SUCCESS:
    case UsersActions.LOAD_CURRENT_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        entities: action.users.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {}),
        ids: action.users.map((x) => x.id),
        msg: null,
        path: null,
        nav: false,
      };

    case UsersActions.UPDATE_ONE:
      return {
        ...state,
        loadingById: {
          ...state.loadingById,
          [action.data.id]: true,
        },
        msg: null,
        nav: false,
      };

    case UsersActions.UPDATE_ONE_SUCCESS:
      return {
        ...state,
        entities: {
          ...state.entities,
          [action.user.id]: {
            ...state.entities[action.user.id],
            ...action.user,
          },
        },
        loadingById: {
          ...state.loadingById,
          [action.user.id]: false,
        },
        path: '/dashboard/user/list',
        msg: null,
        nav: true,
      };

    case UsersActions.UPDATE_ONE_FAILED:
      return {
        ...state,
        loadingById: {
          ...state.loadingById,
          [action.UserId]: false,
        },
        msg: { msg: action.error, status: 'warning' },
        path: null,
        nav: false,
      };

    case UsersActions.CREATE_SUCCESS:
      // ids: action.users.map(x => x.id)
      return {
        ...state,
        entities: {
          ...state.entities,
          [action.user.id]: {
            ...state.entities[action.user.id],
            ...action.user,
          },
        },
        // ids: [...state.ids, action.user.id],
        ids: [...state.ids.filter((x) => x !== action.user.id), action.user.id],
        isLoading: false,
        // msg: { msg: 'Añadido', status: 'success' },
        msg: null,
        path: '/dashboard/user/list',
        nav: true,
      };
    case UsersActions.CREATE_FAILED:
      return {
        ...state,
        isLoading: false,
        msg: { msg: action.error, status: 'warning' },
        path: null,
        nav: false,
      };

    case UsersActions.DELETE_SUCCESS:
      delete state.entities[action.user.UserId];
      // delete state.ids[action.user.UserId];
      return {
        ...state,
        entities: {
          ...state.entities,
        },

        ids: [
          ...state.ids,
          // action.user.id
        ],
      };

    default:
      return state;
  }
}

export const getUsersEntities = (state) => state.users.entities;
export const getUsers = (state) => state.users.ids.map((id) => state.users.entities[id]);
export const getUserById = (state, UserId) => state.users.entities[UserId];
export const getPath = (state) => state.users.path;

// export const getRoles = state => state.users.roles

export const getIsLoading = (state) => state.users.isLoading;
export const getIsLoadingById = (state, UserId) => {
  if (UserId === undefined) {
    return false;
  }

  return state.users.loadingById[UserId];
};
export const getMessage = (state) => state.users.msg;
export const getNav = (state) => state.users.nav;
